import { ReactNode } from 'react';

import classNames from 'classnames';

import * as Dialog from '@radix-ui/react-dialog';

type Props = {
  children?: ReactNode;
  className?: string;
};

export const DialogCancelButton = ({ children = 'Cancel', className = '' }: Props) => {
  return (
    <Dialog.Close className={classNames('msq-btn msq-btn-lg msq-btn-secondary w-full', className)}>
      {children}
    </Dialog.Close>
  );
};
